module.exports = __webpack_public_path__ + "media/images/bsmart/icons/da_svolgere_allenamento-c0ea8569c9b38eb27f2631fe008f8ec0.svg";